import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { BreakpointService } from '@libs/breakpoints';
import { BreadcrumbService } from '@features/layout/breadcrumb/breadcrumb.service';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';
import { RouterLink } from '@angular/router';
import { NgFor, NgClass, NgIf, AsyncPipe, SlicePipe } from '@angular/common';
import { LoadingDotsComponent } from '@shared/loading-dots/loading-dots.component';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgFor, NgClass, RouterLink, NgIf, SvgIconComponent, AsyncPipe, SlicePipe, LoadingDotsComponent]
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
    private unsubscribe: Subject<void> = new Subject();

    public isMobile: boolean = false;

    // sliceStart and sliceEnd is both properties used for slice the breadcrumbs
    // array directly on the template through the slice pipe

    // with the negative will reverse the slicing 2 indexes from the end.
    // this means we only want the last but one index of the array
    public sliceStart: number = 0;
    // the negative value here will tell us to ignore the current page on mobile
    // this means the last index of the array
    public sliceEnd: number | undefined = undefined;

    constructor(
        private readonly cd: ChangeDetectorRef,
        private readonly breakpointService: BreakpointService,
        public readonly breadcrumbService: BreadcrumbService
    ) {}

    ngOnInit(): void {
        this.breakpointService.breakpoint$.pipe(takeUntil(this.unsubscribe)).subscribe(breakpoints => {
            this.isMobile = breakpoints.some(breakpoint => breakpoint.name.includes('mobile'));

            if (this.breakpointService.isBrowser()) {
                this.sliceStart = this.isMobile ? -2 : 0;
                this.sliceEnd = this.isMobile ? -1 : undefined;
            }
        });
    }

    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
